import { Component, Input } from '@angular/core';

interface IMatList {
  name: string;
  icon: string;
  active: boolean;
  id: string[];
  lines: number;
  secondaryText: string;
}

@Component({
    selector: 'myt-resources-card',
    templateUrl: './resources-card.component.html',
    styleUrl: './resources-card.component.scss',
    standalone: false
})
export class ResourcesCardComponent {
  activeIndexOfNavItems = 0;

  @Input() navItems: IMatList[] = [
    {
      name: 'Blog articles',
      icon: 'person',
      active: false,
      id: ['blog'],
      lines: 1,
      secondaryText: '',
    },
    {
      name: 'Tax Calculator',
      active: false,
      id: ['calculator', 'tax-calculator'],
      lines: 1,
      secondaryText: '',
      icon: 'published_with_changes',
    },
  ];

  setActiveNavItem(index: number) {
    this.navItems[this.activeIndexOfNavItems].active = false;
    this.activeIndexOfNavItems = index;
  }
}
